// 时间颗粒度
export enum DateType {
  DAY = 'D',
  WEEK = 'W',
  MONTH = 'M',
  CUSTOM = 'CUSTOM',
}

export const DateTypeDisplay = {
  [DateType.DAY]: '按日',
  [DateType.WEEK]: '按周',
  [DateType.MONTH]: '按月',
  [DateType.CUSTOM]: '自定义',
};

export const ColorMap = ['#52E7FF', '#16DD8E', '#2D8DFF', '#FFCB47', '#854ECA', '#ABD335'];
export const ColorRankMap = ['#FF4D4F70', '#FF6D2C70', '#FFCB4770'];
